import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function MaterialScience(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Material Science</h2>
                <li>
                    <Link to={`${url}/structures`}>Structures of Matter</Link>
                </li>
                <li>
                    <Link to={`${url}/crystalline`}>Structure of Crystalline Solids</Link>
                </li>
                <li>
                    <Link to={`${url}/imperfections`}>Imperfections in Solids</Link>
                </li>
                <li>
                    <Link to={`${url}/diffusion`}>Diffusion</Link>
                </li>
                <li>
                    <Link to={`${url}/dislocations`}>Dislocations</Link>
                </li>
                <li>
                    <Link to={`${url}/strengthening`}>Material Strengthening</Link>
                </li>      
                <li>
                    <Link to={`${url}/failure`}>Material Failure</Link>
                </li>
                <li>
                    <Link to={`${url}/phasechange`}>Phase Changes</Link>
                </li>   
                <li>
                    <Link to={`${url}/polymerstructures`}>Polymer Structures</Link>
                </li>      
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default MaterialScience; 